export default __webpack_public_path__ + "static/media/location.81cb55ff.svg";